// Generated by CoffeeScript 2.7.0
var MessageGroupsSelect;

import {
  PopoverGroupOptionsMixin
} from 'trunks/vue/admin/components/popover_group_options.js';

export default MessageGroupsSelect = Vue.extend({
  mixins: [PopoverGroupOptionsMixin],
  template: `<popover-group-options wrapperClass='message-groups-edit-container'
                       optionsFilterPlaceholder='搜索分组'
                       :initialSelectedOptionIds='initialSelectedMessageGroupIds'
                       optionsUrl='/message_groups'
                       :formatDataFunc='formatMessageGroups'
                       ref='popoverGroupOptionsRef'
                       @cancelClicked='cancelFunc'
                       @submitClicked='submitFunc'
                       @optionsChanged='optionsChangedFunc'>
  <template slot='option-item-template' slot-scope='{ option }'>
    <div class='tip icon'>
      <i :class='option.icon'></i>
    </div>
    <div class='content'>
      <span>{{ option.name }}</span>
    </div>
    <i class='tip primary-text' :class="option._selected ? 'slp-check-circle' : 'slp-empty'"></i>
    </div>
  </template>

  <div slot='filter-blankslate' class='list-group'>
    <div class="list-group-name">没有相关的搜索结果</div>
  </div>

  <div slot='options-blankslate' class='list-group'>
    <div class="list-group-name">没有“分组”</div>
  </div>
</popover-group-options>`,
  props: {
    initialSelectedMessageGroupIds: {
      type: Array
    }
  },
  methods: {
    formatMessageGroups: function(data) {
      if (_.isEmpty(data)) {
        return [];
      } else {
        return [
          {
            id: Skylark.Helpers.Utilities.uuid(),
            options: data
          }
        ];
      }
    }
  }
});
